<div [class.modal]="true" [class.fade]="true" [class.in]="true" role="dialog" [ngStyle]="{'display': 'none'}" id="confirm-delete-dialog" appDraggable dragTarget="#confirm-delete-dialog" dragHandle="#confirmDeleteDialogHeader">
	<div class="modal-dialog modal-sm">
		<!-- Modal content-->
		<div class="modal-content">
			<div class="modal-header" id="confirmDeleteDialogHeader">
				<button type="button" class="close" data-dismiss="modal">x</button>
				<h4 class="modal-title">Delete {{ displayName | capitalize }}</h4>
			</div>
			<div class="modal-body">
				<p>Are you sure you want to delete the following {{ displayName }}? </p>
				<div id="deleteObjectsName" *ngIf="elementNames != null">
					<ng-container *ngFor="let elementName of elementNames">
						<div>{{ elementName }}</div>
					</ng-container>
				</div>
				<p></p>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-default" data-dismiss="modal">NO</button>
				<button type="button" class="btn btn-primary" data-dismiss="modal" (click)="confirm()">YES</button>
			</div>
		</div>
	</div>
</div>
